export default "__VITE_ASSET__BdZXKPL7__"